import dayjs from 'dayjs';

import type {
  ListingPricingValues,
  PricingMonthlyKeys,
} from '@ha/api-v2/types/Listing';
import { ListingPricingType } from '@ha/api-v2/types/Listing';
import { getAllDatesBetweenTwoDates } from '@ha/date';

export const getAllRelevantPrices = ({
  pricingValues,
  pricingType,
  dateFilter,
}: {
  pricingValues: ListingPricingValues;
  pricingType: ListingPricingType;
  dateFilter?: {
    from: string | Date;
    to?: string | Date;
  };
}) => {
  if (!dateFilter?.from || !pricingValues) return [];

  const allDates = getAllDatesBetweenTwoDates({
    startDate: new Date(dateFilter.from),
    endDate: dateFilter.to
      ? new Date(dateFilter.to)
      : dayjs(dateFilter.from).add(12, 'months').toDate(),
  });

  return allDates.flatMap(date => {
    const isMonthlyPriceType = pricingType === ListingPricingType.MONTHLY;
    const preciseDateKey = dayjs(date).format(
      'MM-YYYY',
    ) as `${string}-${string}`;
    const selectedDatePrecisePrice =
      pricingValues?.precise?.[preciseDateKey] ?? 0;

    if (isMonthlyPriceType && selectedDatePrecisePrice) {
      return [selectedDatePrecisePrice];
    }

    const monthDateKey = `m-${dayjs(date).format('MM')}` as PricingMonthlyKeys;
    const selectedDateMonthlyPrice = pricingValues.monthly?.[monthDateKey] ?? 0;

    if (isMonthlyPriceType && selectedDateMonthlyPrice) {
      return [selectedDateMonthlyPrice];
    }

    const flatPrice = pricingValues.flat ?? 0;

    return [selectedDatePrecisePrice || flatPrice];
  });
};
